module.exports = __webpack_public_path__ + "media/fun/fun-3-9f2a40a2.jpg";